<span [ngClass]="options.outerNgClass">
  <ng-container *ngIf="stateError"
                [ngTemplateOutlet]="options.errorTemplate || defaultError"
                [ngTemplateOutletContext]="{
      error: stateError,
      loadCounter: stateLoadCounter,
      context: options.context
    }"
  >
  </ng-container>
  <ng-container *ngIf="stateLoading"
                [ngTemplateOutlet]="options.loadingTemplate || defaultLoading"
                [ngTemplateOutletContext]="{
      loading: stateLoading,
      loadCounter: stateLoadCounter,
      context: options.context
    }"
  >
  </ng-container>
  <ng-container *ngIf="stateContent"
                [ngTemplateOutlet]="options.contentTemplate || defaultContent"
                [ngTemplateOutletContext]="{
      loadCounter: stateLoadCounter,
      content: stateContent,
      reflectedType: stateContentReflectedType,
      context: options.context
    }"
  >
  </ng-container>
</span>

<ng-template #defaultLoading let-loading=loading let-loadCounter=loadCounter>
  <div *ngIf="loading" class="fw-light me-1">Loading...</div>
</ng-template>

<ng-template #defaultError let-error=error>
  <error-panel [error]="error"></error-panel>
</ng-template>

<ng-template #defaultContent let-content=content let-reflectedType=reflectedType>
  <div>
    Loader complete, result type: {{reflectedType}}
  </div>
  <div>
    {{content | json}}
  </div>
</ng-template>
